import ConfigService from './Config';
import BaseService from './Base';

class WorkflowsInstancesService extends BaseService {
  static endpoint = 'api/2.0/workflows-instances/';

  static async getMakeReadyBoard(filters, skipLoading) {
    const url = ConfigService.generateURL(this.endpoint + 'make-ready-board/', filters);
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    const response = await window.fetch(url, {
      method: 'GET',
      headers: {
        Authorization: 'jwt ' + localStorage.getItem('jwt_token'),
        'Time-Zone': jstz.determine().name()
      }
    });
    try {
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    } catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  }
}

export default WorkflowsInstancesService;